module.exports = __webpack_public_path__ + "static/media/button-clear.423e68ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/others/button-clear.svg
// module id = 1442
// module chunks = 0